import { render, staticRenderFns } from "./RolesTableHead.vue?vue&type=template&id=3442ffee&scoped=true&"
import script from "./RolesTableHead.vue?vue&type=script&lang=js&"
export * from "./RolesTableHead.vue?vue&type=script&lang=js&"
import style0 from "./RolesTableHead.vue?vue&type=style&index=0&id=3442ffee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442ffee",
  null
  
)

export default component.exports